<template>
  <div class="feature myMobility notranslate">
    <h1 class="boxTitle mb15 toUppercase">
      {{locale.mobility_my}}
      <button type="button" class="btnRefresh" @click.stop="init"></button>
      <!-- <router-link :to="{name: 'mobility'}" type="button" class="btn btnWhite sizeXs btnMobility">모빌리티 호출</router-link> -->
    </h1>
    <div v-if="!ready" class="noData">{{locale.mobility_my_loading}}</div>
    <div v-else>
      <div class="mb30">
        <p class="subTitle mb5">{{locale.mobility_my_current}}</p>
        <div class="listBox">
          <div v-if="list && list.length > 0" class="mobilityList current">
            <div
              v-for="(item, index) in list"
              :key="index"
              class="item">
              <div class="infoItem mb15">
                <p class="label">{{locale.mobility_request_time}}</p>
                <div class="value">{{ datetimeFormat(item.createat) }}</div>
              </div>
              <div v-if="item.content.destination" class="infoItem mb15">
                <p class="label">{{locale.mobility_destination}}</p>
                <div class="value">{{ item.content.destination }}</div>
              </div>
              <div class="infoItem">
                <p class="label">{{locale.mobility_request_status}}</p>
                <div class="value">
                  {{ getStatus(item).status }}
                  <span v-if="getStatus(item).memo" class="memo">({{ getStatus(item).memo }})</span>
                  <button v-if="item.cancellable" type="button" class="btn btnWhite sizeXs btnCancel" @click.stop="cancelRide(item)">{{ locale.cancel }}</button>
                </div>
              </div>
              <button v-if="item.status !== 'canceled'" type="button" class="btn btnFull btnViewmore" @click="viewDetail(item)">{{locale.mobility_my_realtime}}</button>
            </div>
          </div>
          <div v-else class="noData">{{locale.mobility_my_current_nodata}}</div>
        </div>
      </div>
      <div>
        <p class="subTitle mb5">{{locale.mobility_my_history}}</p>
        <p class="titleMessage mb15">{{locale.message_mobility_my_history}}</p>
        <div class="listBox">
          <div v-if="history && history.length > 0" class="mobilityList">
            <div
              v-for="(item, index) in history"
              :key="index"
              class="item">
              <div class="infoItem mb15">
                <p class="label">{{locale.mobility_request_time}}</p>
                <div class="value">{{ datetimeFormat(item.createat) }}</div>
              </div>
              <div v-if="item.content.destination" class="infoItem mb15">
                <p class="label">{{locale.mobility_destination}}</p>
                <div class="value">{{ item.content.destination }}</div>
              </div>
              <div class="infoItem">
                <p class="label">{{locale.mobility_request_status}}</p>
                <div class="value">
                  {{ getStatus(item).status }}
                  <span v-if="getStatus(item).memo" class="memo">({{ getStatus(item).memo }})</span>
                  <button v-if="item.cancellable" type="button" class="btn btnWhite sizeXs btnCancel" @click.stop="cancelRide(item)">{{ locale.cancel }}</button>
                </div>
              </div>
              <!-- <button v-if="item.status !== 'canceled'" type="button" class="btn btnWhite btnFull btnViewmore" @click="viewDetail(item)">호출상황 보기</button> -->
            </div>
          </div>
          <div v-else class="noData">{{locale.mobility_my_history_nodata}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { DateTime } from 'luxon'

export default {
  name: 'MyMobility',
  props: [
    'locale',
    'ln'
  ],
  computed: {
    format () {
      const setting = this.$store.state.common.setting
      const date = setting.dateFormat[setting.dateformatDefault]
      const time = 'HH:mm:ss'
      return `${date} ${time}`
    },
    timezone () {
      return this.$store.state.siteInfo.timezoneId || ''
    }
  },
  components: {
  },
  async created () {
    this.$store.commit('loading', true)
    await this.$store.dispatch('authentication/getOtaKey')
    this.init()
    this.track()
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') {
        this.init()
      }
    })
  },
  beforeDestroy () {
    document.removeEventListener('visibilitychange', this.init)
  },
  data () {
    return {
      ready: false,
      list: [],
      history: []
    }
  },
  methods: {
    track () {
      const site = this.$store.state.authentication.site
      const routerPath = this.$route.path
      const path = `${site}${routerPath}`
      this.$gtag.pageview({
        page_path: path,
        page_title: 'my mobility'
      })
    },
    init () {
      this.$store.commit('loading', true)
      this.$store.dispatch('guest/getMobilityList').then((res) => {
        this.$store.commit('loading', false)
        this.ready = true
        if (res && (res.items || res.history)) {
          this.list = res.items && res.items.length > 0
            ? res.items.map(x => {
              return {
                ...x,
                status: x.status.toLowerCase(),
                ...x.cancelReason && {
                  cancelReason: x.cancelReason.toLowerCase()
                }
              }
            })
            : []
          this.history = res.history && res.history.length > 0
            ? res.history.map(x => {
              return {
                ...x,
                status: x.status.toLowerCase(),
                ...x.cancelReason && {
                  cancelReason: x.cancelReason.toLowerCase()
                }
              }
            })
            : []
        }
      })
    },
    datetimeFormat (iso) {
      const datetime = DateTime.fromISO(iso, { zone: this.timezone })
      return datetime.toFormat(this.format)
    },
    getStatus (data) {
      const memo = data.status === 'canceled'
        ? this.locale[`mobility_status_${data.status}_${data.cancelReason}`]
        : null
      return {
        status: this.locale[`mobility_status_${data.status}`],
        memo: memo
      }
    },
    viewDetail (data) {
      window.open(data.content.webUrl)
    },
    cancelRide (item) {
      const data = {
        lang: this.ln,
        service: item.service,
        rideId: item.rideId
      }
      this.$store.commit('loading', true)
      this.$store.dispatch('guest/cancelRide', data).then((res) => {
        if (res) {
          if (res.isCancelComplete) {
            alert(this.locale.alert_cancel_complete)
            this.init()
          } else if (res.status && res.status === 403) {
            /**
             * 에러 메시지는 운영사마다 상이하므로 서버에서 반환하는 메시지를 그대로 사용
             * 단, 403은 특정 에러 외 케이스로 locale 메시지 사용
             */
            const resData = res.data && res.data.message
            const status = resData && resData.status
            const errMessage = status && status === 403 ? this.locale.ask_front : resData.message
            alert(errMessage)
            this.searchMap = true
          } else {
            alert(this.locale.system_error)
            this.searchMap = true
          }
        } else {
          alert(this.locale.system_error)
          this.searchMap = true
        }
        this.$store.commit('loading', false)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.boxTitle {
  display: flex;
  align-items: center;
  .btnMobility {
    margin-left: auto;
    padding-top: 0.4em;
    padding-bottom: 0.4em;
    font-size: 12px;
    font-weight: normal;
    border-radius: 4px;
  }
  .btnRefresh {
    position: relative;
    margin-left: 8px;
    width: 24px;
    height: 24px;
    border-radius: 4px;
    border: 1px solid $color-lgrey2;
    background-color: $color-white;
    &:before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: url('~@/assets/img/ico_reload.svg') 50% 50% / 12px no-repeat;
      opacity: 0.5;
    }
  }
}
.subTitle {
  font-size: 16px;
}

.titleMessage {
  font-size: 14px;
  color: $color-grey;
}
.noData {
  padding: 60px 15px;
  text-align: center;
  color: $color-grey;
}
.listBox {
  border-radius: 8px;
  border: 1px solid $color-lgrey2;
}
.mobilityList {
  font-size: 12px;
  &.current {
    font-size: 14px;
    .infoItem {
      .value {
        font-size: 16px;
      }
    }
  }
  .item {
    padding: 15px;
    & + .item {
      border-top: 1px solid $color-lgrey2;
    }
    .subTitle {
      font-size: 20px;
    }
    .btn {
      border-radius: 8px;
    }
    .btnCancel {
      margin-left: 15px;
      font-size: 12px;
      border-radius: 4px;
    }
  }
  .btnViewmore {
    margin-top: 15px;
  }
  .infoItem {
    .label {
      color: $color-grey;
    }
    .value {
      font-size: 14px;
    }
    .memo {
      font-size: 12px;
      color: $color-lgrey;
    }
  }
}
</style>
